import { useEffect, useRef } from 'react';

/**
 * Runs an effect once for the lifetime of a mounted component.
 *
 * The first callback is retained deliberately so subsequent renders cannot
 * change mount/unmount behavior or accidentally retrigger initialization.
 */
export function useMountEffect(effect) {
  const initialEffectRef = useRef(effect);

  useEffect(() => initialEffectRef.current(), []);
}

/** Keeps a stable ref synchronized with the latest rendered value. */
export function useLatestRef(value) {
  const valueRef = useRef(value);
  valueRef.current = value;
  return valueRef;
}
